/**
 * Format scores for display: show as integers 1–5 (trend) or 0–100 (status).
 * Raw values like 0.5, 1.5, 2.1, 2.5, 4.75 are displayed as 1, 2, 2, 3, 5.
 */

/** Trend score (0–5 scale) → integer 1–5 for display */
export function formatTrendScore(score) {
  if (score === null || score === undefined || Number.isNaN(Number(score))) return null;
  const n = Number(score);
  // UN trend scores are 0–5; EU goal CAGR scores can be negative — hide misleading 1–5 display.
  if (n < 0 || n > 5) return null;
  return Math.min(5, Math.max(1, Math.round(n)));
}

/** Status score (0–100 scale) → integer 0–100 for display */
export function formatStatusScore(score) {
  if (score === null || score === undefined || Number.isNaN(Number(score))) return null;
  return Math.round(Number(score));
}
